import striptags from 'striptags';
/**
 * An empty editor still saves markup (<p><br></p>): such a term has nothing
 * to accept.
 * @function termHasContent
 * @since 1.0.0
 */
export function termHasContent(term) {
    var _a, _b;
    if (!term) {
        return false;
    }
    const text = striptags((_a = term.infos) !== null && _a !== void 0 ? _a : '').replace(/&nbsp;/gi, ' ');
    return !!((_b = term.file) === null || _b === void 0 ? void 0 : _b.url) || text.trim() !== '';
}
